if (!customElements.get('ajax-markup-switcher')) {
  class AjaxMarkupSwitcher extends HTMLElement {
    constructor() {
      super();
    }

    sectionsMarkup = null;
    sections = {};
    event = 'click';

    #getSections = async (url) => {
      try {
        const response = await fetch(
          `${url}?sections=${Object.keys(this.sections).join(',')}`,
        );
        if (response.ok) {
          return await response.json();
        }
      } catch (error) {
        console.error(error);
      }
    };

    #setMarkup(sections) {
      for (const [key, value] of Object.entries(sections)) {
        const target = document.querySelector(this.sections[key]);
        if (target) {
          target.classList.add('transparent-transition');
          target.classList.add('transparent');
          const element = new DOMParser()
            .parseFromString(value, 'text/html')
            .querySelector(this.sections[key]);

          element.classList.add('transparent-transition');
          element.classList.add('transparent');
          setTimeout(() => {
            target.outerHTML = element.outerHTML;

            document
              .querySelector(this.sections[key])
              ?.classList.remove('transparent');
          }, 200);
        }
      }
    }

    #onTrigger = async () => {
      if (!this.hasAttribute('data-url')) {
        return;
      }

      this.sectionsMarkup = await this.#getSections(
        this.getAttribute('data-url'),
      );
      this.#setMarkup(this.sectionsMarkup);
      window.history.replaceState({}, null, this.getAttribute('data-url'));

      setTimeout(() => {
        this.afterSwitchCallback();
      }, 250);
    };

    afterSwitchCallback = () => {};

    connectedCallback() {
      this.addEventListener(this.event, () => this.#onTrigger());
    }
  }
  customElements.define('ajax-markup-switcher', AjaxMarkupSwitcher);
}
